import request from "../utils/request";

export const deletePersonalData = async (siteId, visitorId) => {
    return request({
        url: `/visitors/${visitorId}/delete-personal-data`,
        method: "delete",
    });
};

export const fetchChatHistory = async (siteId, visitorId, page, perPage = 5) => {
    return request({
        url: `/visitors/${visitorId}/chat-history?page=${page}&perPage=${perPage}`,
        method: "post",
    });
};



// WEBPACK FOOTER //
// ./src/api/visitor.js